export default __webpack_public_path__ + "static/media/1.09a8640c.png";